import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { useLocation } from 'react-router-dom';
import { API_BASE_URL } from '../config';
import Loader from '../components/Loader';
import "../profiles/homeprofile.css"
import RenovationIcon from '../images/home-landing-page/renovation-icon.png';
import BagIcon from '../images/home-landing-page/bag-icon.png';
import JobsIcon from '../images/home-landing-page/jobs-icon.png';
import MsgsIcon from '../images/home-landing-page/messages-icon.png';
import Slider from "react-slick";
import showToast from '../components/ShowToast';
import Footer from '../components/Footer/footer';
import DashboardNavbar from '../components/Navbar/navbar-dashboard';
//import '../styles/homeUserProfile.css';
import StarRating from '../components/StarRating/startRating';
import emptyprofileImage from '../images/navbar/empty-profile-image.png'
import { jwtDecode } from 'jwt-decode';

const HomeUserProfile = () =>
{
  const [userProfile, setUserProfile] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const [jobPostedCount, setJobPostedCount] = useState(0);
  const [jobCompletedCount, setJobCompletedCount] = useState(0);
  const [expandedItems, setExpandedItems] = useState({});
  const [expandedBusinessReviewsItems, setExpandedBusinessReviewsItems] = useState({});
  const [profileImagePreview, setProfileImagePreview] = useState(null);
  const [uploadingImage, setUploadingImage] = useState(false);
  const userId = queryParams.get('userId') || 62;

  useEffect(() =>
  {
    if (!userId)
    {
      setError('User ID is required');
      setLoading(false);
      return;
    }

    const fetchUserProfile = async () =>
    {
      try
      {
        setLoading(true);
        const userId = jwtDecode(localStorage.getItem('token')).nameid;
        const response = await axios.get(`${API_BASE_URL}/api/HomeUserProfile/getuserprofile?userId=${userId}`);
        setJobPostedCount(response.data.jobs.length);
        setJobCompletedCount(response.data.jobs.filter((job) => job.job_status.toLowerCase() === "completed").length);

        setUserProfile(response.data);
      } catch (err)
      {
        showToast('error', 'Failed to fetch user profile !');
      } finally
      {
        setLoading(false);
      }
    };

    fetchUserProfile();
  }, [userId]);

  const settings = {
    centerMode: true,
    infinite: true,
    slidesToShow: 2,
    speed: 500,
    autoplay: true,
    autoplaySpeed: 3000,
    centerPadding: "0",
    responsive: [
      {
        breakpoint: 1800,
        settings: {
          slidesToShow: 2,
          centerPadding: "0",
        },
      },
      {
        breakpoint: 1499,
        settings: {
          slidesToShow: 2,
          centerPadding: "0",
        },
      },
      {
        breakpoint: 1199,
        settings: {
          slidesToShow: 1,
          centerPadding: "0",
        },
      },
      {
        breakpoint: 991,
        settings: {
          slidesToShow: 1,
          centerPadding: "0",
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          centerPadding: "0",
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          centerPadding: "0",
        },
      },
    ],
  };


  const handleToggle = (id) =>
  {
    setExpandedItems((prev) => ({
      ...prev,
      [id]: !prev[id],
    }));
  };
  const handleToggleBusinessReview = (id) =>
  {
    setExpandedBusinessReviewsItems((prev) => ({
      ...prev,
      [id]: !prev[id],
    }));
  };

  const handleProfileImageChange = async (e) =>
    {
      const file = e.target.files[0];
      if (!file) return;
    
      const reader = new FileReader();
      reader.onloadend = async () =>
      {
        const base64Image = reader.result;
    
        try
        {
          setUploadingImage(true);
    
          const userId = jwtDecode(localStorage.getItem('token')).nameid;
    
          await axios.put(`${API_BASE_URL}/api/HomeOnboarding/update-profile-pic`, {
            userId: userId,
            imageBase64: base64Image
          });
    
          setUserProfile((prev) => ({
            ...prev,
            profilePic: base64Image
          }));
    
          setProfileImagePreview(base64Image);
          showToast('success', 'Profile picture updated!');
        } catch (error)
        {
          showToast('error', 'Failed to update profile picture');
        } finally
        {
          setUploadingImage(false);
        }
      };
    
      reader.readAsDataURL(file);
    };


  return (
    <>
      <DashboardNavbar prefix={''} />
      {loading ? <Loader /> : null}
      <section className="inner-page-banner text-center profile-banner">
        <div className="container">
          <div className="row">
            <div className="col-sm-12 profile-banner-box">
              <div className="profile-image-detail">

              <div style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
                <figure style={{ margin: 0 }}>
                  <img
                    src={profileImagePreview || userProfile?.profilePic || emptyprofileImage}
                    alt="User profile"
                    style={{ width: "132px", height: "132px", borderRadius: "50%", objectFit: "cover" }}
                  />
                </figure>

                <div style={{ marginTop: "10px", textAlign: "center" }}>
                  <label htmlFor="upload-profile-pic" className="btn-upload" style={{ cursor: 'pointer' }}>
                    {uploadingImage ? "Uploading..." : "Change"}
                  </label>
                  <input
                    type="file"
                    id="upload-profile-pic"
                    accept="image/*"
                    style={{ display: "none" }}
                    onChange={handleProfileImageChange}
                  />
                </div>
              </div>

                <div>
                  <h2>{userProfile?.user?.firstName} {userProfile?.user?.lastName}</h2>
                  <p>Location: {userProfile?.user?.suburb} {userProfile?.user?.postcode}</p>
                </div>
              </div>

              <div class="profile-banner-right">
                <div className="profile-action-buttons">
                  {/* <button className="btn">
                    <svg width="23" height="20" viewBox="0 0 23 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M22.68 1.7875C22.06 0.607499 21.03 0.0075 19.65 0.0075C14.22 -0.0025 8.78999 -0.0025 3.35999 0.0075C1.65999 0.0075 0.409988 0.997497 0.0499878 2.5675C0.0399878 2.5975 0.02 2.62751 0 2.64751V13.9775C0.05 14.1475 0.0999731 14.3175 0.159973 14.4875C0.629973 15.8075 1.84 16.6075 3.37 16.6175C3.75999 16.6175 4.15001 16.6175 4.57001 16.6175C4.57001 16.7075 4.57001 16.7775 4.57001 16.8575C4.57001 17.6575 4.58003 18.4475 4.59003 19.2475C4.60003 19.7575 4.96 20.0775 5.44 19.9775C5.58 19.9475 5.72002 19.8675 5.83002 19.7875C7.22002 18.7775 8.61001 17.7675 10.01 16.7575C10.12 16.6775 10.28 16.6275 10.41 16.6275C13.46 16.6175 16.5 16.6175 19.55 16.6275C20.47 16.6275 21.29 16.3775 21.96 15.7775C22.48 15.3175 22.79 14.7575 22.94 14.1075C22.95 14.0675 22.98 14.0275 22.99 13.9875V2.6975C22.9 2.3975 22.83 2.0775 22.68 1.7875ZM21.6 13.3975C21.6 14.5575 20.81 15.2975 19.58 15.2975C16.44 15.2975 13.31 15.2975 10.17 15.2975C9.85998 15.2975 9.60999 15.3775 9.35999 15.5575C8.29999 16.3375 7.22997 17.1075 6.15997 17.8875C6.10997 17.9175 6.05997 17.9575 5.96997 18.0175C5.96997 17.3475 5.96997 16.7175 5.96997 16.0975C5.96997 15.5575 5.70001 15.3075 5.13 15.3075C4.52 15.3075 3.92 15.3175 3.31 15.3075C2.39 15.2975 1.71997 14.8075 1.46997 13.9675C1.41997 13.7875 1.40002 13.5975 1.40002 13.4075C1.40002 10.0175 1.40002 6.62751 1.40002 3.23751C1.40002 2.07751 2.18998 1.33752 3.41998 1.33752C8.79998 1.33752 14.18 1.33752 19.57 1.33752C20.58 1.33752 21.27 1.7975 21.52 2.6675C21.57 2.8475 21.59 3.0375 21.59 3.2275C21.6 6.6275 21.6 10.0075 21.6 13.3975Z" fill="white" />
                    </svg>
                    Message
                  </button> */}
                  <button className="btn">
                    <svg width="29" height="29" viewBox="0 0 29 29" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M28.5701 25.79C28.4201 25.36 28.3201 24.91 28.1201 24.51C27.7101 23.68 27.0301 23.09 26.1801 22.69C26.2401 22.61 26.2801 22.54 26.3301 22.48C26.7201 21.92 26.94 21.3 26.97 20.62C27.05 19.01 26.0701 17.58 24.5701 17.06C23.0601 16.54 21.41 17.1 20.49 18.45C20.39 18.6 20.3 18.6 20.16 18.56C19.21 18.26 18.25 17.96 17.3 17.67C17.15 17.62 17.0901 17.56 17.0701 17.4C16.9301 16.49 16.45 15.82 15.6 15.45C15.46 15.39 15.4501 15.3 15.4501 15.18C15.4501 14.13 15.4501 13.08 15.4501 12.04C15.4501 11.98 15.46 11.92 15.47 11.86C16.64 11.86 17.8001 11.86 18.9601 11.86C19.4701 11.86 19.8201 11.52 19.8201 11.01C19.8301 10.63 19.8301 10.24 19.8201 9.85999C19.8001 9.01999 19.5401 8.25001 19.0601 7.57001C18.6301 6.97001 18.0701 6.52002 17.4001 6.20002C18.5201 4.22002 18.4001 2.57 17.0301 1.31C15.8101 0.190001 14.0101 0.0600134 12.6201 1.01001C11.9501 1.47001 11.4901 2.08999 11.2501 2.85999C10.8801 4.07999 11.1301 5.19001 11.8801 6.19001C10.6901 6.81001 9.97005 7.63001 9.62005 8.73001C9.40005 9.44001 9.44006 10.17 9.44006 10.9C9.44006 11.54 9.75007 11.86 10.3901 11.86C11.3401 11.86 12.28 11.86 13.23 11.86H13.8V15.39C12.8 15.8 12.26 16.56 12.16 17.63C11.15 17.94 10.1601 18.24 9.18005 18.56C8.96005 18.63 8.86003 18.6 8.72003 18.41C7.74003 17.01 5.93006 16.52 4.38006 17.21C2.82006 17.91 1.97007 19.6 2.39007 21.26C2.52007 21.77 2.79006 22.24 3.00006 22.75C3.00006 22.75 2.95008 22.78 2.90008 22.8C1.88008 23.33 1.19008 24.14 0.830075 25.23C0.610075 25.9 0.660063 26.6 0.630063 27.29C0.610063 27.8 0.770048 28.17 1.24005 28.39H10.3701C10.8501 28.22 11.0501 27.88 11.0301 27.37C11.0101 26.66 11.0601 25.95 10.8401 25.26C10.4901 24.16 9.76008 23.32 8.58008 22.72C9.14008 21.99 9.42005 21.17 9.37005 20.22C9.78005 20.1 10.1801 19.97 10.5901 19.85C11.2201 19.65 11.85 19.45 12.49 19.26C12.57 19.24 12.7001 19.27 12.7601 19.33C13.8501 20.49 15.4001 20.49 16.5101 19.32C16.5601 19.27 16.67 19.23 16.73 19.24C17.78 19.56 18.8301 19.88 19.8901 20.21C19.8501 21.14 20.1101 21.97 20.6901 22.71C19.8901 23.09 19.2701 23.63 18.8301 24.36C18.4601 24.97 18.2701 25.64 18.2501 26.35C18.2401 26.66 18.2701 26.97 18.24 27.28C18.2 27.79 18.38 28.16 18.85 28.37H27.98C28.29 28.27 28.4901 28.05 28.6401 27.77V25.91C28.6101 25.86 28.5801 25.82 28.5701 25.79ZM5.83008 18.51C6.88008 18.51 7.74005 19.37 7.74005 20.42C7.74005 21.47 6.88008 22.33 5.83008 22.33C4.78008 22.33 3.92003 21.48 3.91003 20.43C3.91003 19.37 4.77008 18.51 5.83008 18.51ZM9.36004 26.71H2.31006C2.09006 25.65 2.89007 24.42 4.01007 24.1C4.24007 24.03 4.49004 23.99 4.73004 23.99C5.46004 23.98 6.19003 23.98 6.91003 23.99C8.40003 24 9.49004 25.21 9.36004 26.71ZM14.6401 2C15.6901 2 16.54 2.86002 16.54 3.92002C16.54 4.97002 15.6801 5.82999 14.6301 5.82999C13.5801 5.82999 12.7201 4.98 12.7101 3.93C12.7101 2.86 13.5801 1.99 14.6401 2ZM11.1 10.19C10.95 8.86001 11.86 7.64 13.23 7.5C14.16 7.4 15.11 7.4 16.04 7.5C17.4 7.64 18.2401 8.76 18.1801 10.18H11.1V10.19ZM14.6201 18.51C14.1801 18.5 13.8101 18.13 13.8101 17.69C13.8101 17.25 14.1801 16.88 14.6301 16.87C15.0701 16.87 15.4501 17.24 15.4501 17.68C15.4601 18.13 15.0701 18.52 14.6201 18.51ZM23.4501 18.51C24.5001 18.52 25.35 19.38 25.35 20.43C25.35 21.48 24.4901 22.34 23.4401 22.34C22.3801 22.34 21.5201 21.47 21.5301 20.41C21.5301 19.36 22.3901 18.51 23.4501 18.51ZM26.97 26.7H19.9001C19.7601 25.26 20.8501 24.01 22.2801 23.98C23.0001 23.97 23.7201 23.97 24.4401 23.98C25.9801 23.99 27.06 25.13 26.97 26.7Z" fill="white" />
                    </svg>

                    Social
                  </button>
                </div>
              </div>

            </div>
          </div>
        </div>
      </section>


      <section class="profile-page-main-wrapper bottom-hammer-vector">
        <div class="container">
          <div class="profile-page-inner-wrapper">
            <div class="profile-page-left">
              <div class="profile-card-box profile-interested">
                <h2>
                  Interested in
                </h2>
                {userProfile?.constructionInterests.length > 0 ? (
                  <ul>
                    {userProfile?.constructionInterests.map((interest) => (
                      <li key={`interest-${interest.cinterestid || Math.random()}`}>
                        <img src={RenovationIcon} /> {interest.interestName}

                      </li>
                    ))}
                  </ul>
                ) : (
                  <p>No construction interests found.</p>
                )}
              </div>


              <div class="statistics-box">
                <h2>Statistics / Badges</h2>
                <div class="white-card-wrapper">
                  <div class="profile-card-box">
                    <figure>
                      <img src={BagIcon} />
                    </figure>
                    <div class="statistics-detail">
                      <span class="statistics-count"> {jobPostedCount}</span>
                      <span class="statistics-desc">Jobs Posted</span>
                    </div>
                  </div>
                  <div class="profile-card-box">
                    <figure>
                      <img src={JobsIcon} />
                    </figure>
                    <div class="statistics-detail">
                      <span class="statistics-count">{jobCompletedCount}</span>
                      <span class="statistics-desc">Jobs Accepted</span>
                    </div>
                  </div>
                  <div class="profile-card-box">
                    <figure>
                      <img src={MsgsIcon} />
                    </figure>
                    <div class="statistics-detail">
                      <span class="statistics-count">{userProfile?.conversationCount}</span>
                      <span class="statistics-desc">Messages</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>


            <div class="profile-page-right">
              <div class="jobs-posted-sec profile-page-sec">
                <h1>Jobs Posted</h1>

                <div class="job-posted-list">
                  {userProfile?.jobs.length > 0 ? (
                    <div class="">
                      {userProfile?.jobs.length > 2 ?

                        <Slider {...settings}>
                          {userProfile?.jobs.map((job) => (
                            <div class="job-card" key={`job-${job.job_id}`}>
                              <div class="job-image-name">
                                <figure>
                                  <img src={userProfile?.profilePic !== null ? userProfile?.profilePic : emptyprofileImage} />
                                </figure>
                                <div class="job-img-name-inner">
                                  <h3>{job.name}</h3>
                                  <p>{job.country}</p>
                                </div>
                              </div>
                              <p className="job-card-description">
                                {job.description && job.description !== '' ? (
                                  expandedItems[job.job_id] ? (
                                    <>
                                      {job.description}
                                      <a
                                        onClick={() => handleToggle(job.job_id)}
                                        style={{ cursor: 'pointer', color: '#0243A9' }}
                                      >
                                        Read less
                                      </a>
                                    </>
                                  ) : (
                                    <>
                                      {job.description.length > 120
                                        ? `${job.description.substring(0, 120)}...`
                                        : job.description}
                                      {job.description.length > 120 && (
                                        <a
                                          onClick={() => handleToggle(job.job_id)}
                                          style={{ cursor: 'pointer', color: '#0243A9' }}
                                        >
                                          Read more
                                        </a>
                                      )}
                                    </>
                                  )
                                ) : null}
                              </p>

                              <div class="job-status-quote">
                                <p>
                                  Status: <span class={job.job_status !== 'Pending' ? "quote-color open-status" : "quote-color open-status pending-status"}>
                                    {job.job_status}
                                  </span>
                                </p>
                                <p>
                                  Quotes: <span class="quote-count">{job.quoteCount}</span>
                                </p>
                              </div>
                              <div class="job-hiring-status">
                                Hired: {job.job_status !== 'Pending' ? job.business_name : 'None Assigned Yet'}
                              </div>

                            </div>
                          ))}
                        </Slider> :
                        <>
                          {userProfile?.jobs.map((job) => (
                            <div class="job-card" key={`job-${job.job_id}`}>
                              <div class="job-image-name">
                                <figure>
                                  <img src={userProfile?.profilePic !== null ? userProfile?.profilePic : emptyprofileImage} />
                                </figure>
                                <div class="job-img-name-inner">
                                  <h3>{job.name}</h3>
                                  <p>{job.country}</p>
                                </div>
                              </div>
                              <p className="job-card-description">
                                {job.description && job.description !== '' ? (
                                  expandedItems[job.job_id] ? (
                                    <>
                                      {job.description}
                                      <a
                                        onClick={() => handleToggle(job.job_id)}
                                        style={{ cursor: 'pointer', color: '#0243A9' }}
                                      >
                                        Read less
                                      </a>
                                    </>
                                  ) : (
                                    <>
                                      {job.description.length > 120
                                        ? `${job.description.substring(0, 120)}...`
                                        : job.description}
                                      {job.description.length > 120 && (
                                        <a
                                          onClick={() => handleToggle(job.job_id)}
                                          style={{ cursor: 'pointer', color: '#0243A9' }}
                                        >
                                          Read more
                                        </a>
                                      )}
                                    </>
                                  )
                                ) : null}
                              </p>

                              <div class="job-status-quote">
                                <p>
                                  Status: <span class={job.job_status !== 'Pending' ? "quote-color open-status" : "quote-color open-status pending-status"}>
                                    {job.job_status}
                                  </span>
                                </p>
                                <p>
                                  Quotes: <span class="quote-count">{job.quoteCount}</span>
                                </p>
                              </div>
                              <div class="job-hiring-status">
                                Hired: {job.job_status !== 'Pending' ? job.business_name : 'None Assigned Yet'}
                              </div>

                            </div>
                          ))}
                        </>
                      }
                    </div>
                  ) : (
                    <p>No jobs found.</p>
                  )}
                </div>
              </div>

              <div className="Reviews-sec profile-page-sec">
                <div className='review-card'>
                  <h1>Reviews</h1>
                  {userProfile?.reviewOfCustomer.length > 0 ? (
                    <div className="reviews-slider">
                      <div className="testimonial-slider">
                        {userProfile?.reviewOfCustomer.length > 2 ? (
                          <Slider {...settings}>
                            {userProfile.reviewOfCustomer.map((review) => (
                              <div className="testimonial-box-data-main" key={`review-${review.reviewId}`}>
                                <div className="testimonial-box-data">
                                  <figure className="testimonial-user">
                                    <img src={review?.businessUserProfileImage || emptyprofileImage} alt="User  Profile" />
                                  </figure>
                                  <div className="testimonial-stars">
                                    <StarRating ratings={review?.overallRating} />
                                  </div>
                                  <div className="testimonial-text">
                                    <h5>{review.businessName}</h5>
                                    <p>
                                      {review.description && review.description !== '' ? (
                                        expandedBusinessReviewsItems[review.reviewId] ? (
                                          <>
                                            {review.description}
                                            <a
                                              onClick={() => handleToggleBusinessReview(review.reviewId)}
                                              style={{ cursor: 'pointer', color: '#0243A9' }}
                                            >
                                              Read less
                                            </a>
                                          </>
                                        ) : (
                                          <>
                                            {review.description.length > 120
                                              ? `${review.description.substring(0, 120)}...`
                                              : review.description}
                                            {review.description.length > 120 && (
                                              <a
                                                onClick={() => handleToggleBusinessReview(review.reviewId)}
                                                style={{ cursor: 'pointer', color: '#0243A9' }}
                                              >
                                                Read more
                                              </a>
                                            )}
                                          </>
                                        )
                                      ) : null}
                                    </p>
                                  </div>
                                  <div className="testimonial-author">
                                    <h5>{review.businessUserName}</h5>
                                  </div>
                                </div>
                              </div>
                            ))}
                          </Slider>
                        ) : (
                          userProfile.reviewOfCustomer.map((review) => (
                            <div className="testimonial-box-data-main" key={`review-${review.reviewId}`}>
                              <div className="testimonial-box-data">
                                <figure className="testimonial-user">
                                  <img src={review?.businessUserProfileImage || emptyprofileImage} alt="User  Profile" />
                                </figure>
                                <div className="testimonial-stars">
                                  <StarRating ratings={review?.overallRating} />
                                </div>
                                <div className="testimonial-text">
                                  <h5>{review.businessName}</h5>
                                  <p>
                                    {review.description && review.description !== '' ? (
                                      expandedBusinessReviewsItems[review.reviewId] ? (
                                        <>
                                          {review.description}
                                          <a
                                            onClick={() => handleToggleBusinessReview(review.reviewId)}
                                            style={{ cursor: 'pointer', color: '#0243A9' }}
                                          >
                                            Read less
                                          </a>
                                        </>
                                      ) : (
                                        <>
                                          {review.description.length > 120
                                            ? `${review.description.substring(0, 120)}...`
                                            : review.description}
                                          {review.description.length > 120 && (
                                            <a
                                              onClick={() => handleToggleBusinessReview(review.reviewId)}
                                              style={{ cursor: 'pointer', color: '#0243A9' }}
                                            >
                                              Read more
                                            </a>
                                          )}
                                        </>
                                      )
                                    ) : null}
                                  </p>
                                </div>
                                <div className="testimonial-author">
                                  <h5>{review.businessUserName}</h5>
                                </div>
                              </div>
                            </div>
                          ))
                        )}
                      </div>
                    </div>
                  ) : (
                    <p>No business reviews found.</p>
                  )}
                </div>
              </div>

              <div class="Business-Reviews-sec profile-page-sec">
                <div className='review-card'>
                  <h1>Reviews of Businesses</h1>
                  {userProfile?.businessReviews.length > 0 ? (
                    <div class="reviews-slider">
                      <div class="testimonial-slider">
                        {userProfile?.businessReviews.length > 2 ?
                          <Slider {...settings}>
                            {userProfile?.businessReviews.map((review) => (
                              <div class="testimonial-box-data-main" key={`review-${review.reviewid}`}>
                                <div class="testimonial-box-data">
                                  <figure class="testimonial-user">
                                    <img src={userProfile?.profilePic || emptyprofileImage} alt="User  Profile" />
                                  </figure>
                                  <div class="testimonial-stars">
                                    <StarRating ratings={review?.overallRating} />
                                  </div>
                                  <div class="testimonial-text">
                                    <h5>
                                      {review.businessName}
                                    </h5>
                                    <p>
                                      {review.description && review.description !== '' ? (
                                        expandedBusinessReviewsItems[review.reviewId] ? (
                                          <>
                                            {review.description}
                                            <a
                                              onClick={() => handleToggleBusinessReview(review.reviewId)}
                                              style={{ cursor: 'pointer', color: '#0243A9' }}
                                            >
                                              Read less
                                            </a>
                                          </>
                                        ) : (
                                          <>
                                            {review.description.length > 120
                                              ? `${review.description.substring(0, 120)}...`
                                              : review.description}
                                            {review.description.length > 120 && (
                                              <a
                                                onClick={() => handleToggleBusinessReview(review.reviewId)}
                                                style={{ cursor: 'pointer', color: '#0243A9' }}
                                              >
                                                Read more
                                              </a>
                                            )}
                                          </>
                                        )
                                      ) : null}
                                    </p>
                                  </div>
                                  <div class="testimonial-author">
                                    <h5>
                                      {userProfile?.user?.firstName} {userProfile?.user?.lastName}
                                    </h5>
                                  </div>
                                </div>
                              </div>
                            ))}
                          </Slider>
                          :
                          <>
                            {userProfile?.businessReviews.map((review) => (
                              <div class="testimonial-box-data-main" key={`review-${review.reviewid}`}>
                                <div class="testimonial-box-data">
                                  <figure class="testimonial-user">
                                    <img src={userProfile?.profilePic || emptyprofileImage} alt="User  Profile" />
                                  </figure>
                                  <div class="testimonial-stars">
                                    <StarRating ratings={review?.overallRating} />
                                  </div>
                                  <div class="testimonial-text">
                                    <h5>
                                      {review.businessName}
                                    </h5>
                                    <p>
                                      {review.description && review.description !== '' ? (
                                        expandedBusinessReviewsItems[review.reviewId] ? (
                                          <>
                                            {review.description}
                                            <a
                                              onClick={() => handleToggleBusinessReview(review.reviewId)}
                                              style={{ cursor: 'pointer', color: '#0243A9' }}
                                            >
                                              Read less
                                            </a>
                                          </>
                                        ) : (
                                          <>
                                            {review.description.length > 120
                                              ? `${review.description.substring(0, 120)}...`
                                              : review.description}
                                            {review.description.length > 120 && (
                                              <a
                                                onClick={() => handleToggleBusinessReview(review.reviewId)}
                                                style={{ cursor: 'pointer', color: '#0243A9' }}
                                              >
                                                Read more
                                              </a>
                                            )}
                                          </>
                                        )
                                      ) : null}
                                    </p>
                                  </div>
                                  <div class="testimonial-author">
                                    <h5>
                                      {userProfile?.user?.firstName} {userProfile?.user?.lastName}
                                    </h5>
                                  </div>
                                </div>
                              </div>
                            ))}
                          </>
                        }
                      </div>
                    </div>
                  ) : (
                    <p>No business reviews found.</p>
                  )}
                </div>
              </div>

            </div>
          </div>
        </div>
      </section >
      <Footer />
    </>
  );
};

export default HomeUserProfile;
